const ThumbsDownIcon = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 2h7.333v8.667l-4.666 4.666-.834-.833a.875.875 0 0 1-.191-.317 1.09 1.09 0 0 1-.075-.383v-.233l.733-2.9H2a1.28 1.28 0 0 1-.933-.4 1.28 1.28 0 0 1-.4-.934V8c0-.078.01-.161.033-.25a7.79 7.79 0 0 1 .067-.25l2-4.7c.1-.222.266-.411.5-.567C3.5 2.078 3.744 2 4 2Zm6 1.333H4L2 8v1.333h6L7.1 13l2.9-2.9V3.333Zm1.333 7.334V9.333h2v-6h-2V2h3.334v8.667h-3.334Z"
    />
  </svg>
)
export default ThumbsDownIcon
